<template>
  <div>
    <!-- empty Data component -->
    <empty-data v-if="emptyDataFlag" v-bind:text="emptyDataText"></empty-data>

    <!-- 신청서 리스트 -->
    <v-list v-else flat class="doc-list">
      <v-list-item-group>
        <v-list-item
          v-for="item in searchList"
          :key="item.orgApplSeq"
          @click="nextPage(item)"
        >
          <v-list-item-content>
            <v-list-item-title class="doc-title">{{
              item.famRshipCd === 'SE' ? '본인' : '배우자'
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon class="align-self-center ml-1">
            <v-btn fab text width="24" height="24" color="grey">
              <v-icon size="24">mdi-chevron-right</v-icon>
            </v-btn>
          </v-list-item-icon>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
/* 내 신청서 리스트 컴포넌트 */
import EmptyData from '@/components/common/EmptyData.vue';
//import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';

import messageConstants from '@/const/messageConstants.js';
import { getVaccinationList } from '@/api/workStatus';
import { mapGetters } from 'vuex';
//import routerNames from '@/const/routerConstants';

export default {
  props: {
    // 조회요청구분 (MYDOC:내문서, TEMP:임시저장문서, CANCEL:취소신청문서)
    searchReqGubun: {
      type: String,
    },
    // 조회신청서코드 (근태취소신청, 보상휴가취소신청일때만 전달)
    searchApplCd: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      emptyDataFlag: false, // 조회결과없음 플래그
      searchList: [],
      emptyDataText: messageConstants.emptyDataMsg_1,
    };
  },
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_CALLBACK', 'GET_DIALOG_PARAM']),
    ...mapGetters('ELA', ['GET_APPL_CD1']),
    ...mapGetters(['GET_APPL_CD', 'GET_APPL_SEQ']),

    stepChipClass() {
      return applStatusCd => {
        return {
          // 신청서상태코드 (21,31,98:결재처리중,수신처리중,승인요청중 / 23,33:결재반려,수신반려 / 99:처리완료)
          draft: applStatusCd == 23 || applStatusCd == 33,
          charge:
            applStatusCd == 21 || applStatusCd == 31 || applStatusCd == 98,
          approval: applStatusCd == 99,
        };
      };
    },
  },
  watch: {
    GET_DIALOG_CALLBACK(callback) {
      if (callback) {
        this.fetchMyBoxList();
      }
    },
  },
  methods: {
    /* 내문서함 목록조회 */
    async fetchLeaAbsApplList() {
      const params = {
        applSeq: this.GET_APPL_SEQ,
      };

      try {
        const response = await getVaccinationList(params);
        console.dir(response);
        const dataList = response.data.data;

        if (dataList.length > 0) {
          this.searchList = dataList;
        }

        // 조회결과없음 플래그값 세팅
        this.emptyDataFlag = this.searchList.length < 1;

        this.$store.commit('SPINNER/OFF_COMMON_SPINNER'); // 공통 스피너 OFF
        this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', false); // 모달 종료 콜백 OFF
      } catch (error) {
        console.log(error);
      }
    },

    nextPage(item) {
      this.$store.commit('SET_SEQ_NO', item.seqNo);
      this.$store.commit('DIALOG/TOGGLE_MODAL', 'application_viewer');
    },

    useDay(item) {
      const oldDate = new Date(item.orgStaYmd);
      const newDate = new Date(item.orgTmpRestEndPlanYmd);
      let diff = Math.abs(newDate.getTime() - oldDate.getTime());
      diff = Math.ceil(diff / (1000 * 60 * 60 * 24));

      let useDay = diff + 1;

      if (isNaN(useDay)) {
        useDay = '';
      }

      return useDay;
    },
  },
  created() {
    // 공통 스피너 ON
    this.$store.commit('SPINNER/ON_COMMON_SPINNER');
    this.fetchLeaAbsApplList();
  },
  components: {
    EmptyData,
    //ApplMenuIcon,
  },
};
</script>

<style scope>
td {
  text-align: center;
}
</style>
